import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { useThemeConfig } from "@/components/ui/theme-config-provider";
import useDebugPreferences from "@/hooks/useDebugPreferences";
import { useUiPreferences } from "@/hooks/useUiPreferences";

const SettingsDebugSection = () => {
  const {
    visualDebuggerEnabled,
    disableVisualDebugger,
    enableVisualDebugger,
    queryOverrideActive,
  } = useDebugPreferences();
  const { theme } = useThemeConfig();
  const { showVisualDebugger } = useUiPreferences();

  // Don't render the section if visual debugger is not enabled in UI preferences
  if (!showVisualDebugger) {
    return null;
  }

  const handleToggle = (checked: boolean) => {
    if (checked) {
      enableVisualDebugger();
    } else {
      disableVisualDebugger();
    }
  };

  return (
    <div
      className="rounded-lg shadow p-6 mb-6"
      style={{
        borderRadius: theme.borderRadius || "0.5rem",
        backgroundColor:
          theme.cardBackgroundColor || theme.backgroundColor || "#ffffff",
      }}
    >
      <h2
        className="text-xl font-semibold mb-4"
        style={{ color: theme.sectionTitleColor }}
      >
        Debug visivo
      </h2>

      <div className="flex items-center justify-between py-3 gap-4">
        <div className="flex-1">
          <Label
            htmlFor="visual-debugger"
            className="text-base font-medium"
            style={{ color: theme.sectionTextColor }}
          >
            Visual debugger
          </Label>
          <p className="text-sm" style={{ color: theme.sectionTextColor }}>
            Mostra il pannello dei log in tempo reale per analizzare gli eventi
            dell&apos;applicazione durante lo sviluppo.
          </p>
          {queryOverrideActive ? (
            <p
              className="text-xs mt-2"
              style={{ color: theme.sectionTextColor }}
            >
              Il debugger è forzato dalla query <code>?debug=keyboard</code>
              presente nella URL corrente.
            </p>
          ) : null}
        </div>
        <Switch
          id="visual-debugger"
          checked={visualDebuggerEnabled}
          onCheckedChange={handleToggle}
          disabled={queryOverrideActive}
        />
      </div>
    </div>
  );
};

export default SettingsDebugSection;
